import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rest",
  "use": "rest-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rest\">\r\n<path d=\"M11.1667 9.49999H9.5V3.66666H7.83333V9.49999H6.16667V3.66666H4.5V9.49999C4.5 11.2667 5.88333 12.7 7.625 12.8083V20.3333H9.70833V12.8083C11.45 12.7 12.8333 11.2667 12.8333 9.49999V3.66666H11.1667V9.49999ZM15.3333 6.99999V13.6667H17.4167V20.3333H19.5V3.66666C17.2 3.66666 15.3333 5.53332 15.3333 6.99999Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol